import React from 'react'
import { Card } from '@material-ui/core'
import { classList } from 'utils'

const SimpleCard = ({ children, title, subtitle, icon, styles = {} }) => {
    return (
        <Card elevation={6} className={title !==false ? "px-6 py-5 h-full" : "px-5 h-full"} style={styles}>
            {title !==false ?
                <div
                    className={classList({
                        'card-title': true,
                        'mb-4': !subtitle,
                    })}
                    style={{textTransform:"none"}}
                >
                    {title}
                </div>
                :
            false
            }
            {subtitle && <div className="card-subtitle mb-4" >{subtitle}</div>}
            {children}
        </Card>
    )
}

export default SimpleCard
